const benefitsSection = {
  title: 'Benefícios Creditas',
  cards: {
    at_work: {
      title: 'Consignado e benefícios',
      description: 'Benefícios para quem trabalha em empresa conveniada',
    },
  },
};

export { benefitsSection };
